import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleSidebar } from "../../redux/actions/styles";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MenuOpenSharpIcon from "@mui/icons-material/MenuOpenSharp";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchBar from "../../components/SearchBar";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { outlet } = useParams();
  const { sidebarActive } = useSelector((state) => state.styles);
  const { restaurantConfig } = useSelector((state) => state.config);
  const { cart } = useSelector((state) => state.checkout);
  const [menu, setmenu] = useState("manageUsers");

  useEffect(() => {
    if (location.pathname.includes("/users")) {
      setmenu("manageUsers");
    } else {
      setmenu("");
    }
  }, [location.pathname]);

  return (
    <div className={`navbar ${sidebarActive ? "sidebar-active" : ""}`}>
      <div className="nav-left">
        {restaurantConfig.companyLogo ? (
          <div className="logo">
            <img src={restaurantConfig.companyLogo} alt={restaurantConfig.companyName} />
          </div>
        ) : (
          <h3>LOGO</h3>
        )}
        <div className="sidebar-toggle" onClick={() => dispatch(toggleSidebar(sidebarActive ? false : true))}>
          <MenuOpenSharpIcon fontSize="small" style={{ transform: "scaleX(-1)" }} />
        </div>
      </div>
      <div className="nav-middle">{outlet && <SearchBar />}</div>
      <div className="nav-right">
        {window.electron && (
          <div onClick={() => window.location.reload()} className="cart-nav">
            <ShoppingCartIcon fontSize="small" />
            {cart.length > 0 && <div className="badge">{cart.length}</div>}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
